const ROLES = {
    admin: 'admin',
    moderator: 'moderator',
    client: 'client',
    cmoderator: 'cmoderator',
    advertiser: 'advertiser',
    sales: 'sales',
    agency_client: 'agency_client',
    agency: 'agency',
    partners_network: 'partners_network',
    ssp_feed: 'ssp_feed',
    buying: 'buying',
    responsible_manager: 'responsible_manager',
    power_bi: 'power_bi',
    support: 'support',
    dsp_external: 'dsp_external',
    team_master_account: 'team_master_account',
}

export default ROLES